import { render, staticRenderFns } from "./summary.vue?vue&type=template&id=c4fde02a&scoped=true"
import script from "./summary.vue?vue&type=script&lang=js"
export * from "./summary.vue?vue&type=script&lang=js"
import style0 from "./summary.vue?vue&type=style&index=0&id=c4fde02a&prod&scoped=true&lang=css"
import style1 from "./summary.vue?vue&type=style&index=1&id=c4fde02a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4fde02a",
  null
  
)

export default component.exports